// extracted by mini-css-extract-plugin
export default {"boxSelect":"_6711bf2c","selected":"_7f54fe98","disabled":"_fd46d201","disabledSelected":"_3ead5f28","small":"_aea78e8e","medium":"_81f726c","large":"_a4de89ac","box":"_1d983584"};